import { Color } from 'modules/styles/colors';
import {
  FormattedEvent,
  ImagingRelatedData,
  OrderRelatedData,
  PathologyRelatedData,
  SingleLabPanelRelatedData,
  VisitSummaryRelatedData
} from 'serverTypes/event';
import { UpdateTypes } from './enums';
import { Update } from './types';

export const getUpdates = (updates: FormattedEvent[]): FormattedEvent[] => {
  return (updates || []).filter(f =>
    Object.values(UpdateTypes).some(type => type === f.sourceResource)
  );
};

export const getUpdate = (update: FormattedEvent): Update | null => {
  const { read, relatedData } = update;
  const {
    sourceResource,
    medicationName,
    eventDescription,
    labName
  } = relatedData as OrderRelatedData &
    VisitSummaryRelatedData &
    SingleLabPanelRelatedData &
    PathologyRelatedData &
    ImagingRelatedData;

  if (UpdateTypes.LAB === sourceResource || UpdateTypes.LAB === update.sourceResource) {
    return {
      read,
      sourceResource: sourceResource || update.sourceResource,
      eventDescription,
      labName,
      icon: {
        size: 30,
        fill: Color.black,
        name: 'VitalsIcon'
      },
      label: 'Lab results available'
    };
  }

  if (UpdateTypes.PATHOLOGY === sourceResource) {
    return {
      read,
      sourceResource,
      eventDescription,
      icon: {
        size: 30,
        fill: Color.black,
        name: 'TestResultsIcon'
      },
      label: 'Pathology results available'
    };
  }

  if (UpdateTypes.IMAGING === sourceResource) {
    return {
      read,
      sourceResource,
      eventDescription,
      icon: {
        size: 20,
        fill: Color.black,
        name: 'RadiologyImaging'
      },
      label: 'Imaging results available'
    };
  }

  if (UpdateTypes.VISIT_SUMMARY === sourceResource) {
    return {
      read,
      sourceResource,
      eventDescription,
      icon: {
        size: 20,
        fill: Color.black,
        name: 'StethoscopeOnboarding'
      },
      label: 'Visit summary'
    };
  }

  if (UpdateTypes.MEDICATIONS === sourceResource) {
    return {
      read,
      sourceResource,
      medicationName,
      icon: {
        size: 30,
        fill: Color.black,
        name: 'PillBottle'
      },
      label: 'New medication added'
    };
  }

  return null;
};
